import { ExternalLink } from "lucide-react";

import { LoadingState } from "@/components/loading-state";
import { Panel } from "@/components/panel";
import { QueryErrorState } from "@/components/query-error-state";
import { useLatestNews } from "@/sdk/hooks/use-search";

export function FeedsPanel() {
  const { data, isLoading, isError, refetch } = useLatestNews({ limit: 20 });

  if (isLoading) return <LoadingState text="Loading feeds..." />;

  const articles = data?.articles ?? [];

  return (
    <Panel
      title="Latest Headlines"
      description="Compact headline view — the News Feed panel carries the full articles."
    >
      {isError ? (
        <QueryErrorState what="headline feed" onRetry={() => void refetch()} />
      ) : articles.length === 0 ? (
        <p className="py-4 text-center text-sm text-white/40">No headlines available</p>
      ) : (
        <div className="space-y-2">
          {articles.map((article, index) => (
            <div key={index} className="border-b border-white/5 py-2 last:border-0">
              <div className="flex items-start justify-between gap-2">
                <div className="min-w-0">
                  <p className="text-xs font-medium text-white/80">{article.title}</p>
                  <div className="mt-0.5 flex items-center gap-2 text-xs text-white/30">
                    <span>{article.source}</span>
                    {article.published_at && (
                      <span>{new Date(article.published_at).toLocaleDateString()}</span>
                    )}
                  </div>
                </div>
                {article.url && (
                  <a
                    href={article.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="shrink-0 text-white/30 hover:text-white/60"
                  >
                    <ExternalLink className="h-3 w-3" />
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </Panel>
  );
}
